<template>
  <div class='InitTitle'>
    <div class="title">{{ text }}</div>
    <div class="desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  name: 'InitTitle',
  props: {
    text: {
      type: String,
      default: 'Título'
    },
    desc: {
      type: String,
      default: 'Descrição'
    }
  }
}
</script>

<style scoped>
.title {
  font-family: MontSerrat;
  font-weight: 900;
  text-align: left;
  font-size: 24px;
  line-height: 24px;
}

.desc {
  font-size: 12px;
  margin-top: 8px;
  text-align: left;
  color: #333333;
}

@media screen and (max-width: 500px) {
  .title {
    /* text-align: justify; */
    font-size: 18px;
  }
}
</style>
